"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverV2Output = exports.DriverHQ = void 0;
const class_validator_1 = require("class-validator");
const gender_enum_1 = require("../../commons/types/gender.enum");
class DriverNote {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "comfort", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "security", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "timing", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "courtesy", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "nbNotes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverNote.prototype, "average", void 0);
class DriverLanguages {
}
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverLanguages.prototype, "english", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverLanguages.prototype, "german", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverLanguages.prototype, "spanish", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverLanguages.prototype, "french", void 0);
class DriverParams {
}
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverParams.prototype, "seePriceWithTax", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverParams.prototype, "seePriceWithCommission", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverParams.prototype, "canSeePrice", void 0);
class DriverHQ {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverHQ.prototype, "formattedAddress", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverHQ.prototype, "lat", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverHQ.prototype, "lng", void 0);
exports.DriverHQ = DriverHQ;
class DriverV2Output {
    constructor() {
        this.gender = gender_enum_1.GenderEnum.GENDER_MALE;
        this.phoneNumberCountry = 'FR';
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "userKey", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(gender_enum_1.GenderEnum),
    __metadata("design:type", Object)
], DriverV2Output.prototype, "gender", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DriverV2Output.prototype, "phoneNumberCountry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "accountKey", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "outsourcingDriver", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "driverType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], DriverV2Output.prototype, "options", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "managerOnly", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "fleetManager", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "canBeDedicated", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "blacklistedFor", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "blacklisted", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "suspendedFor", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "suspended", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DriverNote)
], DriverV2Output.prototype, "note", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DriverLanguages)
], DriverV2Output.prototype, "languages", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DriverParams)
], DriverV2Output.prototype, "params", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DriverHQ)
], DriverV2Output.prototype, "hq", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverV2Output.prototype, "origin", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "elite", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "accountAdmin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverV2Output.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverV2Output.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "disabilityTrained", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DriverV2Output.prototype, "eligibleToTapToPay", void 0);
exports.DriverV2Output = DriverV2Output;
